"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const settlementManageState_1 = require("@/room/settlement_manage/settlementManageState");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const string_utils_1 = require("@/common/string_utils");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const _1 = require(".");
function default_1() {
    const { total_withdrawable_amount, total_reward_amount } = (0, recoil_1.useRecoilValue)(settlementManageState_1.settlementTotalAmountState);
    const { room_status_cd, fee_free } = (0, recoil_1.useRecoilValue)(settlementManageState_1.settlementDetailsDataState);
    const isBuyerInfoDiscarded = room_status_cd === 'ROOM_STATUS_06';
    const settlementManageTabValue = (0, recoil_1.useRecoilValue)(settlementManageState_1.settlementManageTabValueState);
    const isSettlementDetails = settlementManageTabValue === 'settlementDetails';
    const [expandRewardDetail, setExpandRewardDetail] = (0, react_1.useState)(false);
    (0, react_1.useLayoutEffect)(() => {
        if (isBuyerInfoDiscarded && !total_withdrawable_amount && !!total_reward_amount) {
            setExpandRewardDetail(true);
        }
    }, [isBuyerInfoDiscarded, total_withdrawable_amount, total_reward_amount]);
    const RewardDetailBtn = () => ((0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ onClick: () => setExpandRewardDetail(!expandRewardDetail), sx: {
            p: 0,
            borderRadius: '6px',
            border: '1px solid var(--gray-10)',
            svg: {
                transform: `rotate(${expandRewardDetail ? 180 : 0}deg)`,
            },
        } }, { children: (0, jsx_runtime_1.jsx)(svgs_1.ChevronDownSvg, { css: { width: '18px', height: '18px' } }) })));
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const { t } = (0, react_i18next_1.useTranslation)();
    if (maxWidth768) {
        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { paddingBottom: '10px' } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "subtitle2 gray-80 surface-white", css: {
                        display: 'flex',
                        alignItems: 'center',
                        columnGap: '8px',
                        height: '64px',
                        padding: '0 16px',
                        borderBottom: '1px solid var(--gray-5)',
                    } }, { children: [t('정산 가능'), (0, jsx_runtime_1.jsx)("span", { children: (0, string_utils_1.money)(total_withdrawable_amount) })] })), fee_free && ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "surface-white", css: {
                        padding: '16px',
                        borderBottom: '1px solid var(--gray-5)',
                    } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "body2 gray-80", css: {
                                display: 'flex',
                                alignItems: 'center',
                                columnGap: '8px',
                            } }, { children: [t('사비지킴이'), (0, jsx_runtime_1.jsx)("span", { children: (0, string_utils_1.money)(total_reward_amount) }), isSettlementDetails && (0, jsx_runtime_1.jsx)(RewardDetailBtn, {})] })), isSettlementDetails && (0, jsx_runtime_1.jsx)(_1.RewardDetails, { expand: expandRewardDetail })] })))] })));
    }
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
            display: 'grid',
            gridTemplateColumns: 'fit-content(100%) auto',
            rowGap: '1px',
            borderRadius: '8px',
            border: '1px solid var(--gray-10)',
            backgroundColor: 'var(--gray-10)',
            overflow: 'hidden',
            '.total_amount_name': {
                padding: '13px 14px',
                backgroundColor: 'var(--table-row)',
                '&+div': { padding: '12px 16px' },
            },
        } }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "total_amount_name body2 gray-80" }, { children: t('정산 가능 금액') })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "subtitle4 gray-80 surface-white" }, { children: (0, string_utils_1.money)(total_withdrawable_amount) })), fee_free && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "total_amount_name body2 gray-80" }, { children: t('사비지킴이') })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "surface-white" }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "subtitle4 gray-80", css: { display: 'flex', alignItems: 'center', columnGap: '8px' } }, { children: [(0, string_utils_1.money)(total_reward_amount), isSettlementDetails && (0, jsx_runtime_1.jsx)(RewardDetailBtn, {})] })), isSettlementDetails && (0, jsx_runtime_1.jsx)(_1.RewardDetails, { expand: expandRewardDetail })] }))] }))] })));
}
exports.default = default_1;
